import { Breadcrumb } from 'components/breadcrumb'
import { PageContent } from 'components/layout/PageContent'
import { PivotTable } from 'components/pivot-table/PivotTable'
import React from 'react'

import { AtendimentoProfissional, AtendimentoProfissonalKeyMapping, atendimentos } from './AtendimentoProfissional'

export function AtendimentosProfissionalView(props: any) {
  return (
    <>
      <Breadcrumb title='Atendimento profissional' />

      <PageContent type='filled'>
        <PivotTable<AtendimentoProfissional>
          data={atendimentos}
          keyMapping={AtendimentoProfissonalKeyMapping}
          title='Relatório de atendimentos'
          // TODO (ELDORADO): resolver próxima linha no merge com o next
          dateRangeFilter={null}
        />
      </PageContent>
    </>
  )
}
